<div class="top-section">
  <h6 class="heading mb-0">{{ ss.t('habitNumericalTypeValueInput_placeholder') }}</h6>
  <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>
<div class="flex items-center justify-between ri-p-4">
    <app-input-text [control]="numericControl" name="habitNumericValue" [countShow]="false" [placeholder]="ss.t('habitNumericalTypeValueInput_placeholder')" [hideIcon]="true" [onlyNumbers]="true" maxLength="10" dir="ltr"></app-input-text>
    <p class="text-12-400 color-7 mb-0 unit-block whitespace-nowrap">{{ data.unit }}</p>
</div>
<div class="ri-dialog-footer ri-p-4 flex items-center justify-between">
  <button type="button" class="btn-text text-16-500 color-8 flex items-center" (click)="openTimePicker()"><app-svg class="ri-me-2" name="clock" [color]="ss.theme().color35"></app-svg>{{ ss.getFormattedDate(timestamp.value, 'h:mm a') }}</button>
  <div class="flex items-center">
    <button type="button" class="btn-text text-16-500 color-7 me-4 p-0" (click)="closeDialog()">{{ ss.t('common_buttonCancel') }}</button>
    <button type="submit" class="btn-text text-16-500 color-35 p-0 check-disabled" (click)="save()" [disabled]="!hasChanges() || numericControl.invalid">{{ ss.t('common_save') }}</button>
  </div>
</div>